import { render, staticRenderFns } from "./NotificationStatus.vue?vue&type=template&id=599e9362&"
import script from "./NotificationStatus.vue?vue&type=script&lang=js&"
export * from "./NotificationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports